import React, { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PricesContext = createContext(null);

// Default prices (fallback)
const DEFAULT_PRICES = {
  critical_mistakes: 99,
  critical_mistakes_old: 165,
  ungating: 400,
  supplier_invoice: 200,
  sourcing_pack: 600,
  asin_checker: 350,
  repricer: 200,
  website: null,
  website_text: "Обсудить проект"
};

export const PricesProvider = ({ children }) => {
  const [prices, setPrices] = useState(DEFAULT_PRICES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const res = await fetch(`${API_URL}/api/catalog/prices`);
        if (res.ok) {
          const data = await res.json();
          setPrices({ ...DEFAULT_PRICES, ...data });
        }
      } catch (error) {
        console.error('Error fetching prices:', error);
      }
      setLoading(false);
    };

    fetchPrices();
  }, []);

  // Helper to get price for a product
  const getPrice = (productId) => {
    const key = productId.replace(/-/g, '_');
    return prices[key] ?? DEFAULT_PRICES[key];
  };

  // Helper to get old price
  const getOldPrice = (productId) => {
    const key = `${productId.replace(/-/g, '_')}_old`;
    return prices[key] ?? DEFAULT_PRICES[key];
  };

  // Helper to get price text (for "Обсудить проект" type)
  const getPriceText = (productId) => {
    const key = `${productId.replace(/-/g, '_')}_text`;
    return prices[key] ?? DEFAULT_PRICES[key];
  };

  // Format price for display
  const formatPrice = (productId) => {
    const price = getPrice(productId);
    const priceText = getPriceText(productId);
    
    if (price === null || price === undefined) {
      return priceText || 'Обсудить проект';
    }
    return `$${price}`;
  };

  return (
    <PricesContext.Provider value={{ 
      prices, 
      loading, 
      getPrice, 
      getOldPrice, 
      getPriceText,
      formatPrice,
      refresh: () => window.location.reload()
    }}>
      {children}
    </PricesContext.Provider>
  );
};

export const usePrices = () => {
  const context = useContext(PricesContext);
  if (!context) {
    throw new Error('usePrices must be used within a PricesProvider');
  }
  return context;
};

export default PricesContext;
